import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Boda from './pages/Boda';
import Nosotros from './pages/Nosotros';
import RSVP from './pages/RSVP';
import FAQ from './pages/FAQ';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Boda />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/rsvp" element={<RSVP />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
